
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BoxRequest, Statuses as BoxRequestStatuses, StatusKey as BoxRequestStatusKey } from '@/models/BoxRequest';
import { Options } from '@/components/mi-dialog/MiDialog';

@Component<BlockStatus>({ })
export default class BlockStatus extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private isEditing!: boolean;

  private step: number = this.initialStep;

  private getStepKey(step: number): BoxRequestStatusKey {
    return this.requestStatusKeys[step - 1];
  }

  private getStepLabel(step: number): string {
    return this.requestStatuses[this.requestStatusKeys[step - 1]];
  }

  private handleStepClick(step: number): void {
    this.step = step;
    if (this.step !== this.initialStep) {
      this.$store.dispatch('openDialog', this.editConfirmDialog);
    }
  }

  private changeStep(): void {
    this.$emit('update-status', this.getStepKey(this.step));
  }

  private get requestStatusKeys(): BoxRequestStatusKey[] {
    return Object.keys(this.requestStatuses) as BoxRequestStatusKey[];
  }

  private get requestStatuses(): BoxRequestStatuses {
    return BoxRequest.statuses;
  }

  private get initialStep(): number {
    return Object.keys(this.requestStatuses).indexOf(this.value) + 1;
  }

  private get editConfirmDialog(): Options {
    return {
      title: this.$t('dialogOptions.confirmation').toString(),
      text: `Wil je de status wijzigen naar ${this.getStepLabel(this.step)}?`,
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Ja, status wijzigen',
          action: (): void => {
            this.changeStep();
          }
        },
        cancel: {
          text: this.$t('dialogOptions.button.cancel').toString(),
          action: (): void => {
            this.step = this.initialStep;
          }
        }
      }
    };
  }
}
